export default "__VITE_ASSET__DYgUcbYE__"